import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet-async';
import PosterCard from '../components/PosterCard';
import SearchBar from '../components/SearchBar';
import IntroCard from '../components/IntroCard';
import RecommendationAlert from '../components/RecommendationAlert';
import SuggestionCard from '../components/SuggestionCard';
import ExploreButtons from '../components/ExploreButtons';
import MediaSection from '../components/MediaSection';
import NewsFeed from '../components/NewsFeed';
import DiscoverLinkCard from '../components/DiscoverLinkCard';
import PeriodQuickLinks from '../components/PeriodQuickLinks';
import FeelingAdventurous from '../components/FeelingAdventurous';
// import './HomePage.css';

const HomePage = ({ apiBaseUrl }) => {
  const { isAuthenticated, userRoles } = useAuth();
  const navigate = useNavigate();
  const [currentItems, setCurrentItems] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [recentUpdates, setRecentUpdates] = useState([]);
  const [suggestion, setSuggestion] = useState(null);
  const [recommendations, setRecommendations] = useState([]);
  const [adventurePosters, setAdventurePosters] = useState([]);

  useEffect(() => {
    // Fetch currently engaged items
    fetch(`${apiBaseUrl}/media?filter=current&limit=25`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setCurrentItems(data))
      .catch(err => console.error('Error fetching current items:', err));

    // Fetch recent activity
    fetch(`${apiBaseUrl}/media?sort=last_activity:desc&limit=25`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setRecentActivity(data))
      .catch(err => console.error('Error fetching recent activity:', err));

    // Fetch recent updates
    fetch(`${apiBaseUrl}/media?sort=last_updated:desc&limit=25`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setRecentUpdates(data))
      .catch(err => console.error('Error fetching recent updates:', err));

    // Fetch random suggestion
    fetch(`${apiBaseUrl}/media?filter=suggestion&limit=1`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setSuggestion(data[0] || null))
      .catch(err => console.error('Error fetching suggestion:', err));

    // Random pool for the FeelingAdventurous poster strip, so it's not just the most recent items.
    fetch(`${apiBaseUrl}/media?filter=suggestion&limit=30`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setAdventurePosters(data))
      .catch(err => console.error('Error fetching adventure posters:', err));

    // Fetch recommendations (admin only)
    if (isAuthenticated && userRoles.includes('admin')) {
      fetch(`${apiBaseUrl}/recommendations?status=pending&limit=10`, { credentials: 'include' })
        .then(res => res.json())
        .then(data => setRecommendations(data))
        .catch(err => console.error('Error fetching recommendations:', err));
    }
  }, [apiBaseUrl, isAuthenticated, userRoles]);

  return (
    <div className="home-container">
      <Helmet>
      <title>Y02 Media Database - Explore Anime, Steam Games, and More</title>
        <meta name="description" content="Discover and track your favorite media, including Anime, Manga, Steam Games, Music, and CDs, with Y02 Media Database." />
        <meta name="keywords" content="media database, anime, manga, steam games, music, CDs, Y02" />
        <meta property="og:title" content="Y02 Media Database" />
        <meta property="og:description" content="Track and explore Anime, Manga, Steam Games, Music, and CDs in one place." />
        <meta property="og:image" content="/media-images/banners/banner_generic.jpg" />
        <meta property="og:url" content="https://y02.nl" />
        <meta property="og:type" content="website" />
      </Helmet>
      <IntroCard isAuthenticated={isAuthenticated} />
      {isAuthenticated && userRoles.includes('manage-media') && recommendations.length > 0 && (
        <RecommendationAlert recommendations={recommendations} />
      )}
      <SearchBar apiBaseUrl={apiBaseUrl} />
      <MediaSection title="Recent Activity" items={recentActivity} />
      <ExploreButtons />
      <FeelingAdventurous apiBaseUrl={apiBaseUrl} posterPool={adventurePosters} />
      {/* <DiscoverLinkCard/> */}
      <MediaSection title="Currently Engaged" items={currentItems} />
      <PeriodQuickLinks apiBaseUrl={apiBaseUrl} />
      {suggestion && <SuggestionCard suggestion={suggestion} />}
      <MediaSection title="Recent Updates" items={recentUpdates} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 >Activity Feed</h2>
        <a href="/activityfeed" className="newsfeed-media-link" style={{ textDecoration: 'none' }}>
            View All
            <img src="/static/icons/arrow-right-solid.svg" class="arrow-icon" alt="Arrow"></img>
        </a>
      </div>
      <NewsFeed apiBaseUrl={apiBaseUrl} limit={15} />
    </div>
  );
};

export default HomePage;